module.exports = __webpack_public_path__ + "by.e3816126d1d16d2f5239.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/by.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/by.svg
// module chunks = styles